/** The one MCP endpoint, and how long its export links last. */

/**
 * Where an AI client connects.
 *
 * One entrypoint for the whole product, so this address is the same for
 * everybody -- which workspace a connection acts on comes from the caller's
 * token, not from the URL.
 *
 * `publicBackendUrl` is empty on a single-domain deployment, where the API is
 * reached at the page's own origin. Left as it was that would produce `/mcp`,
 * which is not an address anybody can paste into a client: this is copied out
 * of the browser and used somewhere else, so it has to be absolute.
 */
export function mcpServerUrl(publicBackendUrl: string, origin: string): string {
  const base = publicBackendUrl === '' ? origin : publicBackendUrl
  return `${base.replace(/\/+$/, '')}/mcp`
}

/** A link lifetime in whole minutes where it divides, and in seconds where it does not. */
export function expiry(seconds: number): { unit: 'minutes' | 'seconds'; count: number } {
  return seconds > 0 && seconds % 60 === 0
    ? { unit: 'minutes', count: seconds / 60 }
    : { unit: 'seconds', count: seconds }
}
